module.exports = __webpack_public_path__ + "img/oneid-3.7111633d.png";